import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#0052cc",
    },
    secondary: {
      main: "#edf2ff",
    },
    common: {
      gradient: 'linear-gradient(rgb(30 96 139), rgb(14 57 115))',
    },
  },
});
